<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" @vm-action="deleteServiceConfirm(newRecord)" :vm-action="true" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="true" :vm-is-valid="!$v.newRecord.$invalid" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: $v.newRecord.$invalid },]")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        //- b-form-group
        //-   vm-input(:placeholder='$t("services.contact_placeholder")' :danger="!$v.newRecord.contact.minLength" :danger-text="'Name must have at least 4 ' + $v.newRecord.contact.$params.minLength + ' letters.'" v-model="newRecord.contact" :label='$t("services.contact")')
</template>

<script>
// import { required, minLength, email } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Services')

export default {
  name: 'ModalServices',
  props: {
    newRecord: {
      default: () => {},
      type: Object
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  validations: {
    newRecord: {
      // contact: {
      //   required,
      //   minLength: minLength(5)
      // },
      // email: {
      //   required,
      //   email
      // }
    }
  },
  computed: {
    ...mapGetters([
      'isModalVisible',
      'servicesCatalog'
    ]),
    getTitle () {
      return this.isAdd ? this.$t('services.add') : this.$t('services.edit')
    }
  },
  methods: {
    ...mapActions([
      'addService',
      'editService',
      'deleteService',
      'setModalVisible',
      'loadCatalog'
    ]),
    saveRecord () {
      this.isAdd ? this.addService(this.newRecord) : this.editService(this.newRecord)
    },
    async deleteServiceConfirm (service) {
      let t = this
      this.auxDeleteService = () => {
        t.deleteService(service)
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { attribute: this.$t(service.folio) }),
        accept: this.auxDeleteService
      })
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    close () {
      this.setModalVisible(false)
    }
  }
}
</script>
